module.exports = __webpack_public_path__ + "img/banner-design.026dc5e1.png";